<template>
    <Form
        class="subscribe-form"
        :class="[style]"
        :validation-schema="schema"
        enctype="multipart/form-data"
        method="POST"
        accept-charset="UTF-8"
        autocomplete="off"
        @submit="onSubmitFrm"
        @invalid-submit="onInvalidSubmitFrm"
    >
        <div class="field-box">
            <Field
                id="gemailadres"
                name="gemailadres"
                class="field"
                type="email"
                autocomplete="off"
                :placeholder="'Your Email'"
                @change="(e) => formObjectOnChange(e)"
            />
            <button :disabled="loading" class="submit" type="submit" title="Subscribe">
                <SvgsArrowSRight v-show="!loading" :fill="style == 'light' ? 'var(--dark)' : 'var(--light)'" />
            </button>
        </div>
    </Form>
</template>

<script setup>
    const props = defineProps({
        style: {
            type: String,
            default: "default"
        }
    });

    import { Form, Field } from "vee-validate";
    import { toTypedSchema } from "@vee-validate/zod";
    import { z } from "zod";

    const globalStore = useGlobalStore();
    const { settings } = storeToRefs(globalStore);
    const recipients = settings.value[0].subscribeRecipients.map((item) => item.email);

    const loading = ref(false);
    const zodObj = z.object({
        gemailadres: z
            .string({
                required_error: "Email is required",
                required: true
            })
            .email("Please enter a valid email address")
    });

    const schema = toTypedSchema(zodObj);

    const onSubmitFrm = async (values, actions) => {
        try {
            const { data, error } = await useFetch("/api/send-subscribe", {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: {
                    email: values["gemailadres"],
                    recipients: recipients
                }
            });
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false;
            actions.resetForm();
        }
    };

    const onInvalidSubmitFrm = async ({ values, errors, results }) => {
        const errorsKeys = Object.keys(errors).reverse();
        if (errorsKeys.length) document.getElementById(errorsKeys[0]).focus();
    };

    const formObjectOnChange = (e) =>
        e.target.value != "" ? e.target.classList.add("hasValue") : e.target.classList.remove("hasValue");
</script>
